exports.createPaginatedData = (items, limit, page) => {
  const data = items.slice((page - 1) * limit, page * limit);

  const total = items.length;
  const count = data.length;
  const currentPage = page;
  const firstItem = limit * (page - 1) + 1;
  const lastItem = limit * (page - 1) + count;
  const hasMorePages = lastItem < total;
  const lastPage = Math.ceil(total / limit);
  const perPage = limit;
  const paginatorInfo = {
    count,
    currentPage,
    firstItem,
    hasMorePages,
    lastItem,
    lastPage,
    perPage,
    total,
  };

  return { data, paginatorInfo };
};

exports.createSlug = (name) => {
  name = name.toLowerCase();
  name = name.replace(/\s/g, "-");

  return name;
};

exports.itemsPerPage = 12;
